import logo from '../../image/logo_long_blue.png';

export interface ILogoProps {
    className: string;
}
export const Logo = (props: ILogoProps) => {
    return <img src={logo} className="pr-2 w-full" />;
};
